<template>
  <div v-if="url">
    <div v-if="invalidUrl" class="invalid">
      <img src="@/assets/img/ico_qrcode_svg.svg" alt="" class="invalidImg">
      <p>{{locale.message_qrcode_invalid}}</p>
    </div>
    <span v-else class="qr" :class="{invalid: invalidUrl}">
    <vue-qrcode
      :value="url"
      :color="color"
      :width="size"
      :margin="0"
      :class="'qrImg'" />
    </span>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'Qrcode',
  props: [
    'locale',
    'qrcode',
    'isString',
    'setting',
    'publicOta'
  ],
  components: {
    VueQrcode
  },
  computed: {
    invalidUrl () {
      return !this.url || (this.originUrl && this.originUrl === '#')
    },
    color () {
      const hex = this.setting && this.setting.colorHex && this.setting.colorHex.active
      return {
        light: '#ffffff',
        dark: hex ? this.setting.colorHex.color : '#000000'
      }
    },
    size () {
      const qrcodeSize = this.setting.qrcodeSize && this.setting.qrcodeSize.size
      const size = qrcodeSize && parseInt(qrcodeSize)
      return size
        ? parseInt(size)
        : 256
    }
  },
  watch: {
  },
  mounted () {
    this.$nextTick(() => {
      if (this.qrcode) {
        this.getShortUrl(this.qrcode)
      }
    })
  },
  data () {
    return {
      originUrl: null,
      url: null
    }
  },
  methods: {
    getShortUrl (url) { // qrcode 만들 url은 Module 컴포넌트에서 ota 포함하여 완성한다
      if (!this.isString) {
        const hasExpired = this.setting && this.setting.qrcodeExpired && this.setting.qrcodeExpired.isActive
        this.originUrl = url
        this.$store.dispatch('util/getShortUrl', {
          url: url,
          ...hasExpired && {
            days: this.setting.qrcodeExpired.day
          }
        }).then((res) => {
          this.url = res || '#'
        })
      } else {
        this.url = url
      }
    }
  }
}
</script>
